import type * as React from 'react';
import { get } from '@Domain/Api';
import subjectTypeDefinitionFetched, {
	type SubjectTypeDefinitionFetchedAction,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeDefinitionFetched';
import subjectTypeDefinitionFetchFailed, {
	type SubjectTypeDefinitionFetchFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeDefinitionFetchFailed';
import type { SubjectTypeDefinitionPayload } from '@Application/SubjectTypeDefinitions/Actions/subjectTypeDefinitionsFetched';
import type FetchSubjectTypeDefinition from '@Application/SubjectTypeDefinitions/Queries/FetchSubjectTypeDefinition';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectTypeDefinitionFetchedAction | SubjectTypeDefinitionFetchFailedAction;

export default (query: FetchSubjectTypeDefinition) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<SubjectTypeDefinitionPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}/subject-type-definitions/${query.subjectTypeId}`,
			);

			const action = subjectTypeDefinitionFetched(payload, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectTypeDefinitionFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
